import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectDiscardWarningSummary, selectInstrumentStatus } from '../../state/selectors';
import { displayAsPercent } from '../../../shared/utils/helper';
import { InstrumentStatus } from '../../../shared/models/result.model';
import { isInstrumentTrueErrorBreach } from '../../../shared/utils/discard-threshold.util';

@Component({
  selector: 'app-instrument-errors',
  templateUrl: './instrument-errors.component.html',
  styleUrl: './instrument-errors.component.scss'
})
export class InstrumentErrorsComponent {
  displayedColumns: string[] = [
    'instrumentId',
    'percentTotalErrors',
    'percentTrueErrors',
    'percentFalseErrors',
    'isbDrift'
  ];

  discardedColumns: string[] = [
    'kitLot',
    'instrumentId',
    'beadRegion',
    'discardedCount',
    'analyzedCount',
    'discardedFraction'
  ];

  instrumentStatus$ = this.store.select(selectInstrumentStatus);
  /** Restates the run quality warning so its figures survive the operator dismissing the dialog. */
  discardWarningSummary$ = this.store.select(selectDiscardWarningSummary);
  displayAsPercent = displayAsPercent;

  constructor(private readonly store: Store) {}

  /** Flags instruments the run quality warning would have named, so the dialog is verifiable here. */
  isBreachingInstrument(instrument: InstrumentStatus): boolean {
    return isInstrumentTrueErrorBreach(instrument);
  }
}
